import React from 'react';

import { useGetFiles } from '@vlabs/api/point-api/client';

import { FileItem } from '@vlabs/monokit/entities/data-items/file-item';
import {
  AddCardFileIconButton,
  DeleteCardFileIconButton,
  DownloadFileIconButton,
} from '@vlabs/monokit/features';
import { useCardIdFromLocation } from '@vlabs/monokit/shared/lib/use-card-id-from-location';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { usePersonFilesTranslation } from './i18n';
import st from './PersonFiles.module.sass';

const displayName = 'PersonFiles';
const testid = buildTestid(displayName);

export function PersonFiles(): React.JSX.Element {
  const { t } = usePersonFilesTranslation();

  const cardId = useCardIdFromLocation();
  const getFiles = useGetFiles({ card_ids: [cardId] });

  const files = getFiles.data?.files ?? [];
  const hasFiles = files.length > 0;

  return (
    <div
      className={st.Container}
      {...testid()}
    >
      <div className={st.Header}>
        <h6>{t('title')}</h6>
        <AddCardFileIconButton cardId={cardId} />
      </div>

      {!!hasFiles && (
        <div className={st.FileList}>
          {files.map((file) => (
            <FileItem
              actions={(
                <React.Fragment>
                  <DownloadFileIconButton fileId={file.file_id} />
                  <DeleteCardFileIconButton fileId={file.file_id} />
                </React.Fragment>
              )}
              fileId={file.file_id}
              key={file.file_id}
            />
          ))}
        </div>
      )}

      {!hasFiles && (
        <div className={st.EmptyState}>
          {t('empty')}
        </div>
      )}
    </div>
  );
}
